import React from "react";

const WRAPPER_VARIANTS = {
  system: "mx-auto max-w-2xl",
  user: "flex justify-end",
  error: "space-y-4",
};

const BUBBLE_VARIANTS = {
  system: "bg-blue-50 border border-blue-100 p-4 sm:p-6 rounded-2xl",
  user: "bg-[#e9eef6] text-gray-800 p-3 sm:p-4 rounded-2xl rounded-br-md max-w-2xl",
  error: "bg-red-50 border-l-4 border-red-400 p-3 sm:p-4 rounded-r-lg",
};

export default function MessageBubble({
  type,
  children,
  className = "",
  wrapperClassName = "",
}) {
  const wrapperClass = `${WRAPPER_VARIANTS[type] || ""} ${wrapperClassName}`.trim();
  const bubbleClass = BUBBLE_VARIANTS[type] || "";

  return (
    <div className={wrapperClass}>
      <div className={`${bubbleClass} ${className}`.trim()}>{children}</div>
    </div>
  );
}
